module.exports = __webpack_public_path__ + "media/images/about/a5-666b19b8b480e20bc9f5f6a33e829ca8.png";